import { shallowRef } from 'vue';
import ManualsSubView from './manuals.vue';

export default [{
  manuals: shallowRef(ManualsSubView),
}];
